import type { JSX, PropsWithChildren } from 'react';

import { useCurrentUser } from 'src/app/shared/hooks/session';
import { isLoaded } from 'src/app/shared/utils/async';

import type { LoginOrSignupPagePrefetchedContext } from './hook';
import { usePageContext } from './hook';
import { LoginOrSignupPageDataContextProvider } from './pageData';
import { LoginOrSignupPageStateContextProvider } from './pageState';

type Props = {
	prefetchedData: LoginOrSignupPagePrefetchedContext | undefined;
	loadingFallback: JSX.Element;
};

export function LoginOrSignupPageContextProvider({
	loadingFallback,
	prefetchedData,
	children,
}: PropsWithChildren<Props>): JSX.Element | null {
	const pageContextState = usePageContext(prefetchedData);
	const user = useCurrentUser();

	if (!isLoaded(pageContextState)) return loadingFallback;

	const { pageData } = pageContextState;

	return (
		<LoginOrSignupPageDataContextProvider pageData={pageData}>
			<LoginOrSignupPageStateContextProvider email={user?.email}>{children}</LoginOrSignupPageStateContextProvider>
		</LoginOrSignupPageDataContextProvider>
	);
}
